/**
 * Controls the behavior of the service categories section.
 * Shows one service by default, all on toggle, and restores last viewed or first on close.
 */
document.addEventListener("DOMContentLoaded", () => {
  const dynamicLists = document.querySelectorAll(
    '[data-element-type="service-categories-root"]',
  );

  // Initialize dynamic lists
  dynamicLists.forEach((dynamicList) => {
    /* @type {NodeListOf<HTMLButtonElement>} */
    const serviceIcons = dynamicList.querySelectorAll(".service-icon");

    /* @type {NodeListOf<HTMLDivElement>} */
    const serviceContents = dynamicList.querySelectorAll(".service-content");

    /* @type {HTMLButtonElement} */
    const toggleAllBtn = dynamicList.querySelector(
      '[data-element-type="toggle-all-btn"]',
    );

    let allOpen = false;
    let lastViewedId = serviceContents[0]?.dataset.serviceId || null;

    /**
     * Show only the content for the selected service.
     * @param {string} serviceId
     */
    const showService = (serviceId) => {
      // Close all except selected
      serviceContents.forEach((div) => {
        if (div.dataset.serviceId !== serviceId) {
          div.classList.add("hidden");
        } else {
          // Highlight the selected icon
          serviceIcons.forEach((icon) => {
            if (icon.dataset.serviceId === serviceId) {
              const iconElement = icon.children[0];
              iconElement.classList.remove(
                "bg-surface-light-neutral-white-00", 
                "border-action-primary-surface-on-light",
                "text-action-primary-surface-on-light"
              );
              icon.children[0].classList.add(
                "bg-action-active-surface", 
                "border-action-active-surface", 
                "text-text-primary-on-dark" 
              );
            } else {
              const iconElement = icon.children[0];
              iconElement.classList.remove(
                "bg-action-active-surface", 
                "border-action-active-surface", 
                "text-text-primary-on-dark" 
              );
              iconElement.classList.add(
                "bg-surface-light-neutral-white-00", 
                "border-action-primary-surface-on-light",
                "text-action-primary-surface-on-light" 
              );
            }
          });

          div.classList.remove("hidden");
        }
      });

      // Remember last vied serviceId
      lastViewedId = serviceId;
    };

    /**
     * Show or hide all services.
     * @param {boolean} open
     */
    const toggleAll = (open) => {
      allOpen = open;

      if (open) {
        serviceContents.forEach((div) => div.classList.remove("hidden"));

        //   Highlight all icons
        serviceIcons.forEach((icon) => {
          const iconElement = icon.children[0];
            iconElement.classList.remove(
            "bg-surface-light-neutral-white-00", 
            "border-action-primary-surface-on-light",
            "text-action-primary-surface-on-light" 
          );
          iconElement.classList.add(
            "bg-action-active-surface", 
            "border-action-active-surface", 
            "text-text-primary-on-dark" 
          );
        });

        //   Update button text and icon
        toggleAllBtn.querySelector(
          '[data-element-type="toggle-all-btn-text"]',
        ).textContent = toggleAllBtn.getAttribute("data-toggle-text-close");
        toggleAllBtn.querySelector(":scope > svg").classList.add("rotate-180"); // [data-element-type="toggle-all-btn-icon"]
      } else {
        // Show last viewed or first
        showService(lastViewedId || serviceContents?.dataset.serviceId);

        //  Update button text and icon
        toggleAllBtn.querySelector(
          '[data-element-type="toggle-all-btn-text"]',
        ).textContent = toggleAllBtn.getAttribute("data-toggle-text-open");
        toggleAllBtn
          .querySelector(":scope > svg")
          .classList.remove("rotate-180"); // [data-element-type="toggle-all-btn-icon"]
      }
    };

    // Event listeners for icons
    serviceIcons.forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!allOpen) showService(btn.dataset.serviceId);
      });
    });

    // Event listener for toggle all button
    toggleAllBtn.addEventListener("click", () => {
      toggleAll(!allOpen);
    });

    // Initialize: show first service
    showService(lastViewedId);
  });

  document.querySelectorAll("[data-tabs]").forEach((tabsRoot) => {
    const tabs = Array.from(tabsRoot.querySelectorAll('[role="tab"]'));
    const panels = Array.from(tabsRoot.querySelectorAll('[role="tabpanel"]'));

    function activateTab(tab, moveFocus = true) {
      const targetId = tab.getAttribute("data-tab-target");

      tabs.forEach((t) => {
        const selected = t === tab;
        t.setAttribute("aria-selected", selected ? "true" : "false");
        t.setAttribute("tabindex", selected ? "0" : "-1");
        t.classList.toggle("border-action-active-surface", selected);
        t.classList.toggle("border-transparent", !selected);
        t.dataset.selected = selected ? "true" : "false";
      });

      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });

      if (moveFocus) tab.focus();
    }

    function focusTabByIndex(index) {
      tabs[index].focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => activateTab(tab, false));

      tab.addEventListener("keydown", (event) => {
        let nextIndex = null;

        switch (event.key) {
          case "ArrowRight":
          case "Right":
            nextIndex = (index + 1) % tabs.length;
            break;
          case "ArrowLeft":
          case "Left":
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            break;
          case "Home":
            nextIndex = 0;
            break;
          case "End":
            nextIndex = tabs.length - 1;
            break;
          case "Enter":
          case " ":
            event.preventDefault();
            activateTab(tab, false);
            return;
          default:
            return;
        }

        event.preventDefault();
        focusTabByIndex(nextIndex);
      });
    });

    const initiallySelected =
      tabs.find((tab) => tab.getAttribute("aria-selected") === "true") ||
      tabs[0];

    activateTab(initiallySelected, false);
  });
});
